// JS for block-specific behavior only
console.log('res service pillars block loaded');